export default __webpack_public_path__ + "static/media/onmyway.1ee974e8.mp3";